import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { useParams, useNavigate } from 'react-router-dom';
import { Form } from '@unform/web';
import { Container } from './styles';
import Select, { ActionMeta, OnChangeValue } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import makeAnimated from 'react-select/animated';

import Api, { exceptionNotificationAPI } from '../../services/api';
import getValidationErrors from '../../utils/getValidationErrors';
import { formSelectStyles, formSelectControlFullWidth } from '../FormInput/formSelectStyles';

import Button from '../Button';
import FormInput from '../FormInput';
import CancelButton from '../CancelButton';

const selectWrapperStyle = { width: '100%' };
const selectStylesBase = {
    ...formSelectStyles,
    control: (base, state) => ({ ...formSelectControlFullWidth(base, state) }),
};

const FormCrud = ({ fields, title, formName, isLoading, setSelectedReportYearID = null, multiple = false }) => {
    const navigate = useNavigate();
    const formRef = useRef(null);
    const { id } = useParams();
    const [data, setData] = useState(null);

    const [multipleValues, setMultipleValues] = useState([]);
    const [fieldErrors, setFieldErrors] = useState({});
    const [selectCustomValue, setSelectCustomValue] = useState([]);
    const [selectedCultureOptions, setSelectedCultureOptions] = useState([])
    const [selectCustomInput, setSelectCustomInput] = useState("");
    const [disabledCustomSelect, setDisabledCustomSelect] = useState(true);
    const [companies, setCompanies] = useState(null);
    const [cultures, setCultures] = useState(null);
    const [esgCompanies, setEsgCompanies] = useState([]);
    const animatedComponents = makeAnimated();

    useEffect(() => {
        loadCompanies();
        loadCultures();
    }, []);

    useEffect(() => {
        if (data === null && id != null && !isLoading) {

            loadData();
        }
    }, [isLoading]);

    useEffect(() => {
    }, [selectCustomValue, selectCustomInput]);

    const loadCompanies = async () => {
        await Api.get('Company/getAll').then((result) => {
            if (result && result.data) {
                var companyOptions = result.data.response.map(item => ({ value: item.companyID, label: item.name }));

                companyOptions = [{ value: "", label: "Global" }, ...companyOptions];

                var esgCompaniesOptions = result.data.response.filter(c => c.isESGYear).map(item => ({ value: item.companyID, label: item.name }));

                setCompanies(companyOptions);
                setEsgCompanies(esgCompaniesOptions);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const loadCultures = async () => {
        await Api.get('Culture/getAllCultures').then((result) => {
            if (result && result.data) {
                var cultureOptions = result.data.response.map(item => ({ value: item.cultureID, label: item.cultureDisplayName }));

                setCultures(cultureOptions);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const getObjects = (currentObject, fragments) => {
        if (fragments.length > 0) {
            var object = currentObject[fragments[0]];

            if (object != null) {
                fragments.shift();
                return getObjects(object, fragments);
            }
            else {
                return "";
            }
        }

        return currentObject;
    }

    const loadData = async () => {
        await Api.get(`${formName}/get?id=${id}`).then((result) => {
            if (result && result.data) {
                var dataObj = {};
                var companyOptions = [];
                var groupOptions = [];
                fields.forEach(f => {
                    if (f.name == "sectionCompany" || f.name == "kpiCompany" || f.name == "columnRowCompany" || f.name == "reportYearCompany" || f.name == "yearCompany" || f.name == "groupCompany" || f.name == "operationCompany" || f.name == "moduleCompany") {

                        var dataMultiple = result.data.response[f.name]?.map((sc) => {
                            const id = sc.companyID;
                            const nameFromApi = sc.company?.name ?? sc.Company?.name;
                            const opt = f.options?.find((o) => o.value == id);
                            return {
                                value: opt != null ? opt.value : id,
                                label: nameFromApi ?? opt?.text ?? ''
                            };
                        }) ?? [];
                        setMultipleValues(dataMultiple);
                    } else if (f.name === "culture") {
                        // Check if cultures are present in the response
                        if (result.data.response.cultures != null) {
                            // Map the cultures to create options for the select field
                            const cultureOptions = result.data.response.cultures.map(culture => ({
                                value: culture.cultureID,
                                label: culture.cultureDisplayName
                            }));


                            // Assuming you have a state for the cultures select field
                            setSelectedCultureOptions(cultureOptions);
                        }
                    }
                    else if (f.name == "cultureID") {
                        dataObj[f.name] = result.data.response[f.name];
                    }
                    else if (f.name == "companyCulture") {

                        var dataMultiple = result.data.response[f.name]?.map((sc) => {
                            var data = {
                                value: sc.cultureID,
                                label: sc.culture.description
                            };
                            return data;
                        });
                        setSelectedCultureOptions(dataMultiple);
                        setMultipleValues(dataMultiple);
                    }
                    else if (f.name == "customOptions") {
                        if (result.data.response["customOptions"] != null) {
                            var exist = result.data.response["customOptions"].indexOf(";") > -1;
                            if (exist) {
                                var dataMultiple = result.data.response["customOptions"].split(";");
                                if (formName === "group") {
                                    var newDataMulti = dataMultiple.map((e) => {
                                        var companyName = result.data.response["companies"].find(x => x.companyID === parseInt(e));

                                        var newData = {
                                            "value": e,
                                            "label": companyName.name
                                        }
                                        return newData;
                                    });
                                } else {
                                    var newDataMulti = dataMultiple.map((e) => {
                                        var newData = {
                                            "value": e,
                                            "label": e
                                        }
                                        return newData;
                                    });
                                }
                                if (result.data.response["unitMeasureID"] == 24)
                                    setDisabledCustomSelect(false);
                                else
                                    setDisabledCustomSelect(true);

                                setSelectCustomValue(newDataMulti);
                            } else {
                                if (result.data.response["unitMeasureID"] == 24)
                                    setDisabledCustomSelect(false);
                                else
                                    setDisabledCustomSelect(true);

                                setSelectCustomValue([]);
                            }
                        } else {
                            if (result.data.response["unitMeasureID"] == 24)
                                setDisabledCustomSelect(false);
                            else
                                setDisabledCustomSelect(true);

                            setSelectCustomValue([]);
                        }
                    } else {
                        if (f.name.indexOf(".") > -1) {
                            var fragments = f.name.split('.');

                            var object = getObjects(result.data.response, fragments);

                            dataObj[f.name] = (object != null ? object : "");
                        }
                        else if (f.name == "reportYearID") {
                            if (setSelectedReportYearID != null) {
                                setSelectedReportYearID(result.data.response[f.name]);
                            }
                            dataObj[f.name] = result.data.response[f.name];
                        }
                        else {
                            dataObj[f.name] = result.data.response[f.name];

                            if (formName == "user") {
                                if (f.name == "companyID") {
                                    dataObj[f.name] = dataObj[f.name] !== null ? dataObj[f.name] : "";

                                    if (dataObj["roleID"] == "BA6C43EB-7334-463B-B5CB-D712BD29339D") { //InfoHolder
                                        companyOptions = f.options;
                                    }
                                    else {
                                        companyOptions = f.options;
                                    }
                                }

                            }
                        }
                    }
                });

                formRef.current.setData(dataObj);
                setData(dataObj);

                // Disparar onChanged com valor carregado para aplicar disabled dinâmico no edit
                setTimeout(() => {
                    if (formRef.current) {
                        fields.forEach((f) => {
                            if (f.onChanged && dataObj[f.name] !== undefined) {
                                const syntheticEvent = { target: { value: dataObj[f.name] } };
                                f.onChanged(formRef.current, syntheticEvent);
                            }
                        });
                    }
                }, 0);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }



    const handleSubmit = async (data) => {
        try {
            setFieldErrors({});
            var obj = {}
            var postObj = {};
            const submitUrl = `${formName}/${(id != null) ? "edit" : "new"}`;

            if (formName === "kpi")
                postObj[formName + "id"] = id;
            else {
                if (formName === "user") {
                    postObj["Id"] = id;
                    data['needReadConsent'] = document.getElementById('needReadConsent')?.checked;
                    data['isActive'] = document.getElementById('isActive')?.checked;
                    data['isInternalUser'] = document.getElementById('isInternalUser')?.checked;
                }
                else
                    postObj[formName + "ID"] = id;
            }

            if (selectedCultureOptions != null && selectedCultureOptions.length > 0) {
                if (formName == "user") {
                    data["culture"] = selectedCultureOptions.map(option => ({
                        cultureID: option.value ? option.value : 0
                    }));
                }
                else if (formName == "company") {
                    data["companyCulture"] = selectedCultureOptions.map(option => ({
                        cultureID: option.value ? option.value : 0
                    }));
                }
                else if (formName == "group") {
                    data["cultureID"] = selectedCultureOptions.value;
                }
                else {
                    data["culture"] = {
                        cultureID: selectedCultureOptions.value ? selectedCultureOptions.value : 0
                    };
                }
            }


            fields.map(f => {
                if (f.required !== undefined && f.required === false) {
                    if (f.name === "calculation") {
                        if (data["inputCalc"] === "Calculation") {
                            var calculationFields = ["firstValue", "operation", "secondValue"];

                            calculationFields.map(item => {
                                return obj[item] = Yup.string().required(`${f.label} is required`);
                            });
                        }

                        return null;
                    } else {
                        return null;
                    }
                }
                else {
                    if (f.editable !== undefined && f.editable === false) {
                        return null;
                    } else if (f.multiple) {
                        return obj[f.name] = Yup.array()
                            .of(Yup.object().required())
                            .required(`${f.label} is required`)
                            .min(1, `${f.label} is required`);
                    }
                    else {
                        return obj[f.name] = Yup.string().required(`${f.label} is required`);
                    }
                }
            })


            const schema = Yup.object().shape(obj);

            await schema.validate(data, {
                abortEarly: false,
            });

            fields.map(f => {
                return postObj[f.name] = data[f.name]
            })

            // FIXO, CUIDAR (CUSTOM OPTIONS)
            if (selectCustomValue.length > 0) {
                postObj.customOptions = selectCustomValue.map((e) => { return e.value }).join(';');
            }

            var selector = formName + "Company"
            // FIXO, CUIDAR (SECTION COMPANY)
            if (multipleValues.length > 0) {
                postObj[selector] = multipleValues.map((m) => {
                    var data = {
                        companyID: m.value ? m.value : 0
                    }
                    return data;
                });
            }



            await Api.post(submitUrl, postObj);

            if (formName === "unitMeasure") {
                navigate(`/answerTypeKPI`);
            } else if (formName === "user" || formName === "culture" || formName === "reportYear") {
                window.location.href = `/${formName}`;
            } else {
                navigate(`/${formName}`);
            }
        } catch (error) {
            if (error instanceof Yup.ValidationError) {
                const errors = getValidationErrors(error);
                setFieldErrors(errors);
                formRef.current.setErrors(errors);
                return;
            }

            exceptionNotificationAPI(error);
        }
    }

    return (
        <Container className="container">
            <div>
                <h3>{(id != null) ? "Edit" : "New"} {title}</h3>
                <Form onSubmit={handleSubmit} ref={formRef}>
                    <table className="table table-striped">
                        <tbody>
                            {
                                fields.map((f, i) => {
                                    if (f.type === "selectcustom" && formName != "Group") {
                                        return <>
                                            <tr key={i + "Tr"} id={f.name + "Tr"}>
                                                <td>
                                                    <label>
                                                        {`${f.label}`}  {f.required === undefined || f.required === true ? <span className="required">*</span> : <></>}
                                                    </label>
                                                </td>
                                                <td>
                                                    {formName == "group" ?

                                                        <div style={selectWrapperStyle}>
                                                        <Select
                                                            name="customOptions"
                                                            id="customOptions"
                                                            isClearable={false}
                                                            placeholder="Select one or more companies..."
                                                            onChange={(e) => { setSelectCustomValue(e); }}
                                                            value={selectCustomValue}
                                                            inputValue={selectCustomInput}
                                                            closeMenuOnSelect={false}
                                                            components={animatedComponents}
                                                            isMulti
                                                            options={companies}
                                                            styles={selectStylesBase}
                                                            classNamePrefix="form-select"
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                        />
                                                        </div>
                                                        :
                                                        <div style={selectWrapperStyle}>
                                                        <CreatableSelect
                                                            name="customOptions"
                                                            id="customOptions"
                                                            isDisabled={disabledCustomSelect}
                                                            components={{ DropdownIndicator: null }}
                                                            isClearable={false}
                                                            isMulti
                                                            menuIsOpen={false}
                                                            placeholder="Type something and press enter..."
                                                            onChange={(e) => { setSelectCustomValue(e); }}
                                                            onInputChange={(e) => setSelectCustomInput(e)}
                                                            onKeyDown={(e) => {
                                                                switch (e.key) {
                                                                    case 'Enter':
                                                                    case 'Tab':
                                                                        if (selectCustomInput == "")
                                                                            return;
                                                                        var newData = {
                                                                            "value": selectCustomInput,
                                                                            "label": selectCustomInput
                                                                        }
                                                                        var newArray = [...selectCustomValue, newData];
                                                                        setSelectCustomInput("");
                                                                        setSelectCustomValue(newArray);
                                                                        e.preventDefault();
                                                                }
                                                            }}
                                                            value={selectCustomValue}
                                                            inputValue={selectCustomInput}
                                                            styles={selectStylesBase}
                                                            classNamePrefix="form-select"
                                                        />
                                                        </div>
                                                    }
                                                </td>
                                            </tr>
                                        </>
                                    }
                                    else if (f.type === "select") {
                                        if (f.name === "calculation") {
                                            return <>
                                                <tr key={i + "Tr"} id={f.name + "Tr"}>
                                                    <td>
                                                        <label>
                                                            {`${f.label}`}  {f.required === undefined || f.required === true ? <span className="required">*</span> : <></>}
                                                        </label>
                                                    </td>
                                                    <td style={{ display: "flex" }}>
                                                        <div style={{ width: "45%" }}>
                                                            <FormInput
                                                                name="firstValue"
                                                                id="firstValue"
                                                                inputType={f.type}
                                                                placeholder={{ value: "", text: "" }}
                                                                options={f.options}
                                                                onChange={() => (f.onChanged != null) ? f.onChanged(formRef.current) : null}
                                                                hideAlert={true} />
                                                        </div>
                                                        <div style={{ width: "10%" }}>
                                                            <FormInput
                                                                name="operation"
                                                                id="operation"
                                                                placeholder={{ value: "", text: "" }}
                                                                options={[
                                                                    { value: "+", text: "+" },
                                                                    { value: "-", text: "-" },
                                                                    { value: "/", text: "/" },
                                                                    { value: "*", text: "*" },
                                                                    { value: "Average", text: "Average" },
                                                                ]}
                                                                inputType={"select"}
                                                                onChange={() => (f.onChanged != null) ? f.onChanged(formRef.current) : null}
                                                                hideAlert={true} />
                                                        </div>
                                                        <div style={{ width: "45%" }}>
                                                            <FormInput
                                                                name="secondValue"
                                                                id="secondValue"
                                                                inputType={f.type}
                                                                placeholder={{ value: "", text: "" }}
                                                                onChange={() => (f.onChanged != null) ? f.onChanged(formRef.current) : null}
                                                                options={f.options} /></div>
                                                    </td>
                                                </tr>
                                                <tr key={i + "CalculationTr"}>
                                                    <td>Calculation (Formula)</td>
                                                    <td>
                                                        <FormInput
                                                            disabled
                                                            name={f.name}
                                                            id={f.name}
                                                            inputType="input"
                                                            placeholder={f.placeholder}
                                                            options={f.options} />
                                                    </td>
                                                </tr>
                                            </>
                                        } else {
                                            return <tr key={i + "Tr"} id={f.name + "Tr"}>
                                                <td width="25%">
                                                    <label>
                                                        {`${f.label}`}  {f.required === undefined || f.required === true ? <span className="required">*</span> : <></>}
                                                    </label>
                                                </td>
                                                <td width="75%">
                                                    {
                                                        f.name == "culture" || f.name == "companyCulture" ?
                                                            <div style={selectWrapperStyle}>
                                                            <Select
                                                                name={f.name}
                                                                id={f.name}
                                                                options={f.options.map((o) => ({
                                                                    value: o.value,
                                                                    label: o.text
                                                                }))}
                                                                onChange={(selectedOptions) => {
                                                                    setSelectedCultureOptions(selectedOptions);
                                                                    setFieldErrors(prev => ({ ...prev, [f.name]: undefined }));
                                                                }}
                                                                value={selectedCultureOptions}
                                                                placeholder="Select a culture..."
                                                                closeMenuOnSelect={false}
                                                                isMulti={f.multiple}
                                                                styles={{
                                                                    ...selectStylesBase,
                                                                    control: (base, state) => ({
                                                                        ...formSelectControlFullWidth(base, state),
                                                                        ...(fieldErrors[f.name] ? { borderColor: '#e71700', boxShadow: '0 0 0 1px #e71700' } : {})
                                                                    })
                                                                }}
                                                                classNamePrefix="form-select"
                                                                menuPortalTarget={document.body}
                                                                menuPosition="fixed"
                                                            />
                                                            </div> :
                                                            !f.multiple ?
                                                                <FormInput
                                                                    name={f.name}
                                                                    id={f.name}
                                                                    checked={f.checked}
                                                                    value={data?.[f.name]}
                                                                    inputType={f.type}
                                                                    placeholder={f.placeholder}
                                                                    options={f.options}
                                                                    disabled={f.disabled ? f.disabled : false}
                                                                    onChange={(a) => {
                                                                        if (data != null) {
                                                                            setData((prev) => (prev ? { ...prev, [f.name]: a.target.value } : prev));
                                                                        }
                                                                        if (f.name == "unitMeasureID" && a.target.value != 24) {
                                                                            setDisabledCustomSelect(true);
                                                                            setSelectCustomValue([]);
                                                                        } else if (f.name == "unitMeasureID" && a.target.value == 24) {
                                                                            setDisabledCustomSelect(false);
                                                                            setSelectCustomValue([]);
                                                                        } else {
                                                                            setDisabledCustomSelect(true);
                                                                        }

                                                                        if (f.onChanged != null && formRef.current != null) {
                                                                            f.onChanged(formRef.current, a);
                                                                        }
                                                                        return;
                                                                    }} />
                                                                :

                                                                <div style={selectWrapperStyle}>
                                                                <Select
                                                                    options={f.name == "reportYearCompany" || f.name == "yearCompany" ?
                                                                        companies
                                                                        : f.options.map((o) => ({ value: o.value, label: o.text }))}
                                                                    value={multipleValues}
                                                                    isMulti
                                                                    closeMenuOnSelect={false}
                                                                    onChange={(a) => {
                                                                        setMultipleValues(a);
                                                                        setFieldErrors(prev => ({ ...prev, [f.name]: undefined }));
                                                                    }}
                                                                    styles={{
                                                                        ...selectStylesBase,
                                                                        control: (base, state) => ({
                                                                            ...formSelectControlFullWidth(base, state),
                                                                            ...(fieldErrors[f.name] ? { borderColor: '#e71700', boxShadow: '0 0 0 1px #e71700' } : {})
                                                                        })
                                                                    }}
                                                                    classNamePrefix="form-select"
                                                                    menuPortalTarget={document.body}
                                                                    menuPosition="fixed"
                                                                />
                                                                </div>}
                                                </td>
                                            </tr>
                                        }
                                    }
                                    else {
                                        if (id !== undefined && f.editable !== undefined && f.editable === false) {
                                            return <></>
                                        }
                                        else {
                                            return <tr key={i + "Tr"} id={f.name + "Tr"}>
                                                <td width="25%">
                                                    <label>
                                                        {`${f.label}`}  {f.required === undefined || f.required === true ? <span className="required">*</span> : <></>}
                                                    </label>
                                                </td>
                                                <td width="75%">
                                                    <FormInput
                                                        className="form-control"
                                                        name={f.name}
                                                        id={f.name}
                                                        disabled={f.disabled ? f.disabled : false}
                                                        checked={f.checked}
                                                        value={data?.[f.name]}
                                                        inputType={f.type}
                                                        onChange={(a) => {
                                                            if (data != null && a?.target != null) {
                                                                const v = f.type === 'check' ? a.target.checked : a.target.value;
                                                                setData((prev) => (prev ? { ...prev, [f.name]: v } : prev));
                                                            }
                                                        }} />
                                                </td>
                                            </tr>
                                        }
                                    }
                                })
                            }
                        </tbody>
                    </table>
                    <div className="d-flex flex-row mt-2">
                        <CancelButton />
                        <Button type="submit">Save</Button>
                    </div>
                </Form>
            </div>
        </Container>
    );
}

export default FormCrud;
